/* eslint-disable import/prefer-default-export */
export const BPTooltips = {
  pulsePressure: 'Pulse pressure (PP) is the difference between systolic and diastolic pressures in the heart. Although a large PP measured at the brachial artery with use of the cuff method is not an accurate representation of the proximal aortic PP, it does suggest a stiffened aorta, which may increase the vulnerability of the heart to ischemia',
};
